module.exports = __webpack_public_path__ + "img/phonesQR.f6ff9ed9.png";